import React, { useEffect, useState } from "react";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NumberFormat from "react-number-format";

// import CreateTicket from "../../../components/CreateTicket/createTicket";
// import PopupWrapper from "../../../components/PopupWrapper";
// import TicketTable from "../../Ticket/TicketTable";
import useTickets from "./apis/useTickets";
import AccountSummary, { PortfolioLoansModal } from "./AccountSummary";
import PaymentSummary from "./PaymentSummary";
// import LoanNumber from "./LoanNumber";
import VisualRepresentation from "./VisualRepresentation";
import Payments from "./Payments";
import QuickAccess from "./QuickAccess";
import UpComingPayment from "./UpComingPayment";
import PastPayment from "./PastPayment";
import OpenActivePayOff from "./OpenActivePayOff";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import imb_upcoming_payments from "../../../assets/images/portfolio-balance.png";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerDefaultLoans, fetchVOMRequestsForBorrower,  fetchPayoffDemandsThirdParty, } from "../../../store/reducers/dashboardSlice/api";
import { fetchNsfData } from "../../../store/reducers/nsfSlice/api";
import { useAbortController } from "../../../hooks/useAbortController";
import imb_portfolio_balance from "../../../assets/images/upcoming-payments.png";
import {
  CheckCircleFill,
  InfoCircleFill,
  QuestionCircleFill,
} from "react-bootstrap-icons";
// import InsuranceExpiryModal from "./InsuranceExpiringWithIn30Days";
import useAchData from "../BankAccountACHPayments/useAchData";
import {
  SpinnerBlock,
  TaxFormsAnnouncement,
} from "../../../Utils/CustomComponent";
import { useNavigate } from "react-router-dom";
import LoanMaturity from "./LoanMaturity";
import InsuranceExpiringWithIn30Days from "./InsuranceExpiringWithIn30Days";
import { gridColumns_DefaultManagementCommon } from "../../../Utils/TableColumnDefs";
import TicketCard from "./TicketCard";
import UrgentNsfModal from "../../../components/UrgentNsfModal";
import { formatNumbers } from "../../../Utils";
import VOMPendingModal from "../../VerificationForm/VOMPendingModal";
import VOMBanner from "../../VerificationForm/VOMBanner";

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) return value;
  }
  return null;
}
const BorrowerDashboardTwo = () => {
  // const [showCreateTicket, setShowCreateTicket] = useState(false);
  const [showLandingModal, setShowLandingModal] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  // const [viewAll, setViewAll] = useState(false);
  // const [activeTab, setActiveTab] = useState(0);
  // const [showInsuranceExpiry, setShowInsuranceExpiry] = useState(false);
  // const [showWorkout, setShowWorkout] = useState(false);
  // const [showBankruptcy, setShowBankruptcy] = useState(false);

  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  // const workoutLoans = useSelector(
  //   (state) => state.dashboard.borrowerDefaultWorkout.data
  // );
  // const bankruptcyLoans = useSelector(
  //   (state) => state.dashboard.borrowerDefaultBankruptcy.data
  // );
  const defaultStatus = useSelector(
    (state) => state.dashboard.borrowerDefaultBankruptcy.status,
  );
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const { activeAccountList, totalAccountList } = useBorrowerDashboardTwo();
  const { data: nsfData, status: nsfStatus } = useSelector(
    (state) => state.nsf.nsfData,
  );
  const vomRequests = useSelector(
    (state) => state.dashboard.borrowerVOMRequests.data,
  );
  const vomStatus = useSelector(
    (state) => state.dashboard.borrowerVOMRequests.status,
  );
  const pendingRequests =
    vomRequests?.filter((item) => item?.status === "PENDING") ?? [];
  // const tickets = useTickets(refreshTable);
  const { enrolledLoansCount, notEnrolledLoansCount, secondLoader } = useAchData();
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loanIdArr = activeAccountList?.map((el) => el.value).join(",") || [];
  const isRoc = selectedAccount?.databasename === "ROC";

  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const accounts = useSelector((state) => state.account.accountOptions)
    .map((data) => data.value)
    .join(" ");
  const accountsNumber = useSelector(
    (state) => state.account.accountOptions,
  ).map((data) => data.label.split(" - ")[1]);

  // Determine if there are actual NSF issues present
  const hasNsfIssues =
    nsfStatus === loadingTypes.fulfilled &&
    !!nsfData &&
    ((nsfData?.totalRecords ?? 0) > 0 ||
      Math.abs(nsfData?.TotalNSFAmount ?? 0) > 0 ||
      (nsfData?.totalNSFFee ?? 0) > 0 ||
      (nsfData?.uniqueAccounts ?? 0) > 0);

  const hasVOMPending = pendingRequests?.length;

   useEffect(() => {
      dispatch(
        fetchPayoffDemandsThirdParty({
          email: email,
          signal,
        }),
      );
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  useEffect(() => {
    if (defaultStatus === loadingTypes.idle) {
      dispatch(
        fetchBorrowerDefaultLoans({
          requestBody: {
            borrowerRecID: totalAccountList?.map((el) => el.value).join(" "),
          },
          signal,
        }),
      );
    }
  }, [dispatch, defaultStatus, totalAccountList?.length]);

  useEffect(() => {
    dispatch(fetchNsfData({ accounts, accountsNumber }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, dispatch]);

  useEffect(() => {
    if (accounts?.length) {
      dispatch(
        fetchVOMRequestsForBorrower({
          payload: { loanrecid: accounts?.split(" ") },
        }),
      );
    }
  }, [dispatch, accounts]);

  useEffect(() => {
    if (nsfStatus === loadingTypes.fulfilled) {
      if (hasNsfIssues) {
        setActiveModal("NSF");
      } else if (hasVOMPending) {
        setActiveModal("VOM");
      } else {
        setActiveModal(null);
      }
    }
  }, [hasNsfIssues, hasVOMPending, nsfStatus]);

  // Auto-show modal only when NSF issues actually exist
  useEffect(() => {
    if (nsfStatus === loadingTypes.fulfilled && hasNsfIssues) {
      // Check if user clicked "Remind me later" recently
      const remindLaterTimestamp = localStorage.getItem("nsfRemindLater");
      if (remindLaterTimestamp) {
        const timeSinceReminder = Date.now() - parseInt(remindLaterTimestamp);
        const oneMinute = 60 * 1000; // 1 minute in milliseconds

        if (timeSinceReminder < oneMinute) {
          // Don't show modal yet, wait for 1 minute
          setShowLandingModal(false);
          return;
        } else {
          // 1 minute has passed, clear the timestamp
          localStorage.removeItem("nsfRemindLater");
        }
      }
      setShowLandingModal(true);
    }
  }, [nsfStatus, hasNsfIssues]);

  const handleCloseLandingModal = () => {
    setShowLandingModal(false);
    // Close NSF
    setActiveModal(null);

    // Auto-open VOM if needed
    if (hasVOMPending) {
      setActiveModal("VOM");
    }
  };

  const handleSign = () => {
    // navigate to VOM signing page
    navigate("/voms/borrower");
  };

  const handleRemindLater = () => {
    // Store current timestamp when user clicks "Remind me later"
    localStorage.setItem("nsfRemindLater", Date.now().toString());
    setShowLandingModal(false);
  };

  return (
    <div className="pb-0 d-flex">
      {/* Urgent NSF Issues Modal - Auto-shows on page load */}
      {activeModal === "NSF" && hasNsfIssues && (
        <UrgentNsfModal
          nsfData={nsfData}
          show={showLandingModal}
          onHide={handleCloseLandingModal}
          onHandleNow={() => navigate("/nsf")}
          onReviewLater={handleRemindLater}
        />
      )}
      {activeModal === "VOM" && (
        <VOMPendingModal
          show
          onClose={() => setActiveModal(null)}
          pendingCount={pendingRequests?.length}
          onSign={handleSign}
        />
      )}

      <section
        className="rounded container-fluid p-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div
          className="row gap-sm-5 gap-lg-0"
          // style={{ height: "100vh" }}
        >
          <ErrorBoundary>
            <Container className="p-3 border">
              {/* <Row className="mb-1 gx-0">
                <Col md={12} className="px-3 py-4">
                  <TaxFormsAnnouncement />
                </Col>
              </Row> */}
              {nsfStatus === loadingTypes.loading ? (
                <Row className="mb-1 gx-0">
                  <Col md={12} className="px-3 py-4">
                    <div
                      className="d-flex align-items-center justify-content-center p-4 rounded"
                      style={{ minHeight: "80px" }}
                    >
                      <SpinnerBlock height="10vh" />
                    </div>
                  </Col>
                </Row>
              ) : hasNsfIssues ? (
                <Row className="mb-1 gx-0">
                  {/* NSF Alert Banner */}
                  <Col
                    md={12}
                    className="px-3 py-4"
                    style={{ borderColor: "navy" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-between p-4 rounded"
                      style={{
                        backgroundColor: "#fdf2f2",
                        border: "1px solid #fecaca",
                        minHeight: "80px",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="d-flex align-items-center justify-content-center me-3"
                          style={{
                            backgroundColor: "#fee2e2",
                            borderRadius: "50%",
                            width: "48px",
                            height: "48px",
                            color: "#dc2626",
                          }}
                        >
                          <svg
                            width="24"
                            height="24"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2v-2zm0-6h2v4h-2v-4z" />
                          </svg>
                        </div>
                        <div>
                          <div className="fw-bold text-dark fs-5 mb-1">
                            {nsfData?.totalRecords} Payments Failed Due to
                            Insufficient Funds
                          </div>
                          <div className="text-muted">
                            Total amount:{" "}
                            <strong>
                              {formatNumbers(Math.abs(nsfData?.TotalNSFAmount))}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div>
                        <Button
                          variant="danger"
                          className="d-flex align-items-center"
                          style={{
                            backgroundColor: "#dc2626",
                            borderColor: "#dc2626",
                            fontWeight: "500",
                            padding: "10px 20px",
                          }}
                          onClick={() => {
                            navigate("/nsf");
                          }}
                        >
                          Resolve NSF Issues
                          <svg
                            className="ms-2"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                          </svg>
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null}

              {vomStatus === loadingTypes.loading ? (
                <Row className="mb-1 gx-0">
                  <Col md={12} className="px-3 py-4">
                    <div
                      className="d-flex align-items-center justify-content-center p-4 rounded"
                      style={{ minHeight: "80px" }}
                    >
                      <SpinnerBlock height="10vh" />
                    </div>
                  </Col>
                </Row>
              ) : hasVOMPending ? (
                <VOMBanner count={pendingRequests?.length} />
              ) : null}

              <Row className=" mb-1 gx-0">
                {/* Accounts Summary */}
                <Col
                  md={6}
                  className="px-3 py-4"
                  style={{ borderColor: "navy" }}
                >
                  <AccountSummary />
                </Col>

                {/* Payment Summary */}
                <Col
                  md={6}
                  className="px-3 py-4"
                  // className=" h-100 border border-primary"
                  style={{ borderColor: "navy" }}
                >
                  <PaymentSummary loanIdArr={loanIdArr} />
                </Col>

                {/* Loan Number Section */}
                {/* <Col
                  md={4}
                  className="px-3 py-4"
                  style={{ borderColor: "navy" }}
                >
                  <LoanNumber />
                </Col> */}
              </Row>

              {!isRoc ? (
                <Row className="g-0 mb-3">
                  <Col md={4} className="px-3 py-3 ">
                    <VisualRepresentation />
                  </Col>

                  {/* Payments Section */}
                  <Col md={4} className="px-3 py-3 ">
                    <Payments setRefreshTable={setRefreshTable} />
                  </Col>

                  {/* Quick Access Section */}
                  <Col md={4} className="px-3 py-3 ">
                    <QuickAccess />
                  </Col>
                </Row>
              ) : (
                <Row className="g-0 mb-3">
                  {/* Payments Section */}
                  <Col md={6} className="px-3 py-3 ">
                    <Payments setRefreshTable={setRefreshTable} />
                  </Col>

                  {/* Quick Access Section */}
                  <Col md={6} className="px-3 py-3 ">
                    <QuickAccess />
                  </Col>
                </Row>
              )}
              <Row className="g-4 mb-4">
                <Col md={4}>
                  <UpComingPayment isRoc={isRoc} />
                </Col>

                {/* Progress Bars & Pay Now Button */}

                <Col md={4}>
                  <div className="h-100 d-flex flex-column gap-3">
                    {/* <DefaultCards
                      title={"Loans in Workout"}
                      value={
                        defaultStatus === loadingTypes.fulfilled
                          ? workoutLoans.length
                          : defaultStatus === loadingTypes.loading
                          ? "-"
                          : 0
                      }
                      prefix={""}
                      decimalScale={0}
                      onClick={() => setShowWorkout((prev) => !prev)}
                      role={"button"}
                    />

                    <DefaultCards
                      title={"Loans in Bankruptcy"}
                      value={
                        defaultStatus === loadingTypes.fulfilled
                          ? bankruptcyLoans.length
                          : defaultStatus === loadingTypes.loading
                          ? "-"
                          : 0
                      }
                      prefix={""}
                      decimalScale={0}
                      onClick={() => setShowBankruptcy((prev) => !prev)}
                      role={"button"}
                    /> */}
                    {/* <DefaultSection /> */}
                    <div className="row g-4">
                      <div className="col-md-12 achStatus">
                        <div className="card h-100 shadow-sm p-3 border border-primary pulse-card">
                          {!secondLoader ? (
                            <div className="card-body d-flex flex-column">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h5 className="card-title mb-0">ACH Status</h5>
                                <span
                                  className="text-muted"
                                  data-bs-toggle="tooltip"
                                  title="Shows the number of loans currently set up on recurring ACH payments and loans without ACH enrollment"
                                >
                                  <QuestionCircleFill />
                                </span>
                              </div>
                              <div
                                role="button"
                                className="clickable-card-ach"
                                onClick={() =>
                                  navigate("/ach-payment", {
                                    state: { activeTab: 0 },
                                  })
                                }
                              >
                                <div className="d-flex align-items-center mb-1">
                                  <span className="text-success fs-3 me-2">
                                    <CheckCircleFill color="var(--primary-color)" />
                                  </span>
                                  <h2 className="mb-0">{enrolledLoansCount}</h2>
                                </div>
                                <p className="text-muted small mb-2">
                                  On recurring ACH
                                </p>
                              </div>
                              <div className="mt-auto">
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() =>
                                    navigate("/ach-payment", {
                                      state: { activeTab: 1 },
                                    })
                                  }
                                >
                                  {notEnrolledLoansCount} Not Enrolled
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <SpinnerBlock height="10vh" />{" "}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Loans Maturing Card */}
                      <div className="col-md-12">
                        <LoanMaturity />
                      </div>

                      <div className="col-md-12">
                        <InsuranceExpiringWithIn30Days />
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <PastPayment />
                </Col>
              </Row>

              <Row className="g-4 mb-4">
                <Col md={12}>
                  <OpenActivePayOff loanIdArr={loanIdArr} />
                </Col>
              </Row>
            </Container>
          </ErrorBoundary>
        </div>
      </section>
      <style>
        {`
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            background-color: rgba(0, 0, 0, 0.5); 
            width: 30px;
            height: 30px;
          }
        `}
      </style>

      {/* <PortfolioLoansModal
        show={showWorkout}
        setShow={setShowWorkout}
        data={workoutLoans}
        status={defaultStatus}
        title={"Loans in Workout"}
      />
      <PortfolioLoansModal
        show={showBankruptcy}
        setShow={setShowBankruptcy}
        data={bankruptcyLoans}
        status={defaultStatus}
        title={"Loan in bankruptcy"}
      /> */}
    </div>
  );
};

export default BorrowerDashboardTwo;

// const TicketsTableModal = ({
//   show,
//   setShow,
//   activeTab,
//   setActiveTab,
//   refreshTable,
//   setTabsData,
// }) => {
//   return (
//     <div>
//       <PopupWrapper
//         Component={
//           <ErrorBoundary>
//             <TicketTable
//               activeTab={activeTab}
//               setActiveTab={setActiveTab}
//               refreshTable={refreshTable}
//               setTabsData={setTabsData}
//             />
//           </ErrorBoundary>
//         }
//         title="Tickets"
//         toShow={show}
//         closeEventHandler={() => {
//           setShow(false);
//         }}
//       />
//     </div>
//   );
// };

export const DefaultCards = ({
  title,
  value,
  prefix,
  decimalScale,
  src = imb_upcoming_payments,
  onClick = null,
  role = null,
  conditionalBorder = false,
  h100 = false,
  className = "",
}) => {
  return (
    <Card
      className={`p-3 d-flex border-primary flex-column ${
        conditionalBorder ? "border-0" : ""
      } ${h100 ? "h-100" : ""} ${className}`}
      onClick={onClick}
      role={role}
    >
      <p className="fw-bold d-flex align-items-center">
        <img style={{ width: "75px", paddingRight: "10px" }} src={src} alt="" />{" "}
        <div>{title}</div>
      </p>
      <p className="pt-0 mb-0 fs-4 ps-3" style={{ color: "#555" }}>
        <strong>
          <NumberFormat
            displayType="text"
            value={value}
            prefix={prefix}
            fixedDecimalScale={true}
            decimalScale={decimalScale}
            thousandSeparator={true}
          />
        </strong>
      </p>
    </Card>
  );
};

export const DefaultSection = () => {
  const [showWorkout, setShowWorkout] = useState(false);
  const [showBankruptcy, setShowBankruptcy] = useState(false);

  const defaultStatus = useSelector(
    (state) => state.dashboard.borrowerDefaultBankruptcy.status,
  );
  const workoutLoans = useSelector(
    (state) => state.dashboard.borrowerDefaultWorkout.data,
  );
  const bankruptcyLoans = useSelector(
    (state) => state.dashboard.borrowerDefaultBankruptcy.data,
  );
  const data = useSelector(
    (state) => state.dashboard.borrowerPastDue31DaysLoans.data,
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerPastDue31DaysLoans.status,
  );

  const calculatePrincipalBalanceSum = (data) => {
    return data.reduce(
      (sum, loan) => sum + (loan["Principal Balance"] || "-"),
      0,
    );
  };

  const principalBalanceSum = calculatePrincipalBalanceSum(data);

  return (
    <>
      <div className="">
        <div className="d-flex flex-row gap-3">
          <div className="w-100 border border-primary card">
            <DefaultCards
              title={"Default Portfolio Balance"}
              value={
                status === loadingTypes.fulfilled
                  ? principalBalanceSum
                  : status === loadingTypes.loading
                    ? "-"
                    : 0
              }
              prefix={"$"}
              decimalScale={2}
              src={imb_portfolio_balance}
              conditionalBorder={true}
            />
          </div>
        </div>

        {/* <div className="d-flex flex-row gap-3 pt-3">
          <div className="w-50 border border-primary card">
            <DefaultCards
              title={"Total Number of Defaults"}
              value={
                status === loadingTypes.fulfilled
                  ? data.length
                  : status === loadingTypes.loading
                  ? "-"
                  : 0
              }
              prefix={""}
              decimalScale={0}
              conditionalBorder={true}
            />
          </div>

          <div className="w-50 border border-primary card">
            <DefaultCards
              title={"Loans in Bankruptcy"}
              value={
                defaultStatus === loadingTypes.fulfilled
                  ? bankruptcyLoans.length
                  : defaultStatus === loadingTypes.loading
                  ? "-"
                  : 0
              }
              prefix={""}
              decimalScale={0}
              onClick={() => setShowBankruptcy((prev) => !prev)}
              role={"button"}
              conditionalBorder={true}
            />
          </div>
        </div> */}
      </div>

      <PortfolioLoansModal
        show={showWorkout}
        setShow={setShowWorkout}
        data={workoutLoans}
        status={defaultStatus}
        title={"Loans in Workout"}
        gridColumns={gridColumns_DefaultManagementCommon}
      />
      <PortfolioLoansModal
        show={showBankruptcy}
        setShow={setShowBankruptcy}
        data={bankruptcyLoans}
        status={defaultStatus}
        title={"Loan in bankruptcy"}
        gridColumns={gridColumns_DefaultManagementCommon}
      />
    </>
  );
};
